import React from 'react';
import { DesktopTimePicker } from '@mui/x-date-pickers/DesktopTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { TextField } from '@mui/material';
import { TimePickerContainer } from './styles';
import { TimeIcon } from 'assets/icons';
import moment from 'moment-timezone';
import { TIME_ZONE } from 'constants/constant';

const TimePicker = ({
  disabled,
  error,
  TimeValue,
  setTime,
  additionalstyle,
  variant,
}) => {

  //remove ownerState warning from MUI icon
  const CleanTimeIcon = React.forwardRef(({ ownerState, ...props }, ref) => (
    <TimeIcon ref={ref} {...props} />
  ));

  return (
    <TimePickerContainer additionalstyle={additionalstyle} disabled={disabled}>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <DesktopTimePicker
          slots={{
            openPickerIcon: TimeIcon,
            textField: TextField,
          }}
          slotProps={{
            textField: {
              variant,
              autoComplete: "off",
              error: Boolean(error),
              helperText: error ? "Invalid time" : "",
            },
          }}
          disabled={disabled}
          fullWidth
          label=" "
          format="hh:mm A"
          error={error}
          value={TimeValue}
          onChange={(e)=> {
            setTime(moment(e).tz(TIME_ZONE))
          }}
        />
      </LocalizationProvider>
    </TimePickerContainer>
  );
};

export default TimePicker;
